import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowCircleLeftComponent } from "./med-icon-arrow-circle-left.component";

@NgModule({
  declarations: [
    MedIconArrowCircleLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowCircleLeftComponent,
  ],
})
export class MedIconArrowCircleLeftModule { }
